import { HandleSSOCallback } from '@clerk/react';
import { CircleNotch } from '@phosphor-icons/react';
import { Stack } from '@reelplicate/ui';
import { useNavigate } from 'react-router';

import { useRedirectTarget, withRedirect } from './redirect-target';

/**
 * Where Google and GitHub send the browser back. Clerk finishes the sign-in or
 * sign-up here (possibly showing a captcha), then we route on - to the
 * `redirect_url` the OAuth buttons put on this URL, or home. Meanwhile a
 * centred spinner says what's happening.
 */
export function SsoCallbackPage() {
  const navigate = useNavigate();
  const target = useRedirectTarget();
  return (
    <Stack
      gap={3}
      align="center"
      aria-busy="true"
      className="min-h-svh justify-center px-4"
    >
      <CircleNotch
        aria-hidden
        className="text-icon-brand size-8 animate-spin [animation-duration:800ms] motion-reduce:[animation-duration:1600ms]"
      />
      <p role="status" className="text-body-md text-text-secondary">
        Signing you in…
      </p>
      <HandleSSOCallback
        navigateToApp={() => void navigate(target, { replace: true })}
        navigateToSignIn={() =>
          void navigate('/sign-in/provider-error', { replace: true })
        }
        navigateToSignUp={() =>
          void navigate(withRedirect('/sign-up', target), { replace: true })
        }
      />
    </Stack>
  );
}
